<template>
  <div v-if="hasLayout">

    <div class='desktop-panel' v-if="isFlowLayout">
    <div v-for="layout in layouts" :key="layout.id" class = 'item-box' >
        <img :src="layout.coverImg" @click="layoutSelected(layout.id)" />
        <div class="legend " v-bind:class="{ center: layout.labelAlign =='center' }" >{{ layout.label }}</div>
      </div>
</div>


    <swiper ref="mySwiper" :options="swiperOptions" v-else>
      <swiper-slide v-for="layout in layouts" :key="layout.id">
        <img :src="layout.coverImg" @click="layoutSelected(layout.id)" />
        <div class="legend " v-bind:class="{ center: layout.labelAlign =='center' }" >{{ layout.label }}</div>
      </swiper-slide>

        <swiper-slide v-if="displayPromo">
        <img :src="promoSlideUrl" @click="promoSelected()" />

      </swiper-slide>

    </swiper>


  </div>
</template>

<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';

const promoSlide = require('../assets/promo-slide.jpg');

export default {
  components: {
    Swiper,
    SwiperSlide,
  },

  props: {
    layouts: { type: Array, required: true },
    displayPromo: { type: Boolean, required: true },
  },

  directives: {
    swiper: directive,
  },

  data() {
    return {
      picUrl: '',
      message: '',
      selectionEnabled: true,


      swiperOptions: {
        slidesPerView: 1.5, /*     */
        spaceBetween: 20,
        freeMode: true,

        pagination: {

        },

        navigation: {

        },

        // Some Swiper option/callback...
      },
    };
  },

  computed: {
    swiper() {
      if (!this.$refs.mySwiper) {
        return null;
      }
      return this.$refs.mySwiper.$swiper;
    },

    isFlowLayout() {
      return this.$store.largeScreenLayout;
    },

    hasLayout() {
      return this.layouts != null;
    },

    promoSlideUrl() {
      return promoSlide;
    },
  },

  methods: {
    layoutSelected(layout) {
      if (!this.selectionEnabled) {
        return;
      }

      this.$emit('themeSelected', layout);
    },

    promoSelected() {
      this.$emit('promoSelected');
    },
  },

  mounted() {
    if (this.swiper) {
      this.swiper.on('setTranslate', () => {
        this.selectionEnabled = false;
        clearTimeout(this.$clickTimeout);
        this.$clickTimeout = setTimeout(() => {
          this.selectionEnabled = true;
        }, 100);
      });
    }
  },


  destroyed() {
    if (this.swiper) {
      this.swiper.off('setTranslate');
    }
  },
};
</script>

<style scoped>

.desktop-panel{

  display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;

}

.desktop-panel .item-box img{
  max-height: 300px;
  margin: 0.6em 0.6em;
   border-radius: 8px;
}


.swiper-container {
  width: 100%;
  height: 100%;
  background: transparent;
  margin-top: 1.2em;
 /* min-height: 200px;*/

 max-height:300px;
}


.swiper-slide {

}

.item-box, .swiper-slide {

  text-align: center;
  font-size: 18px;

  max-width: 100%;

height: auto;
  cursor: pointer;

  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;

}


.swiper-slide img {
  max-width: 100%;
   /*height: auto;*/
   max-height: 100%;
  border-radius: 8px;
}

.swiper-slide .legend {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  color: #fff;
  padding: 5px;
  text-shadow: 0px 0px 6px rgba(0, 0, 0, 1), 0px 0px 6px rgba(0, 0, 0, 1);
  line-height: 1;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
}

.swiper-slide .legend.center{
  text-align: center;
    text-shadow:none;
}
</style>
